import { useStepperContext } from "../../../context/stepper-provider";
import { useNavigate, useParams } from "react-router-dom";
import Define from "@/components/define/define";
import PalletConfig from "@/components/pallet-config/pallet-config";
import LpnNo from "@/components/LPN-No";
import PreShip from "@/components/pre-ship/pre-ship";
import PostShip from "@/components/post-ship/post-ship";
import PostStack from "@/components/post-stack/post-stack";
import Summary from "@/components/summary/summary";
import Synopsis from "@/components/synopsis";
import Navbar from "@/components/top-nav";
import StepperNavigation from "../../../components/StepperNavigation";
import ShipTestTruckLayout from "@/components/post-ship/ship-test-truck-layout";
import StackTestLayout from "@/components/post-stack/stack-test-layout";
import Images from "@/components/imagesTab/images";
import Stepper from "@/components/stepper";
import { setActivePallet } from "@/redux/slices/pallet/palletSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
export default function EditProject() {
    const { stepper } = useStepperContext();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    console.log('Project ID:', id);
    useEffect(()=>{
        return ()=>{
            dispatch(setActivePallet(null))
        }
    },[])   
    return (
        <>
        <Navbar />
        <div className="">

            <Stepper />

            {stepper.when("1", () => (
                <Define projectId={id} />
            ))}
            {stepper.when("2", () => (
                <div className=" overflow-y-hidden">
                <PalletConfig projectId={id} />
                </div>
            ))}
            {stepper.when("3", () => (
                <LpnNo projectId={id} />
            ))}
            {stepper.when("4", () => (
                <PreShip projectId={id} />
            ))}
            {stepper.when("5", () => (
                <ShipTestTruckLayout projectId={id}     />
            ))}
            {stepper.when("6", () => (
                <PostShip projectId={id} />
            ))}
            {stepper.when("7", () => (
                <StackTestLayout projectId={id}     />
            ))}
            {stepper.when("8", () => (
                <PostStack projectId={id} />
            ))}
            {stepper.when("9", () => (
                <Summary projectId={id} />
            ))}
            {stepper.when("10", () => (
                <Synopsis projectId={id} />
            ))}
            {stepper.when("11", () => (
                <Images projectId={id} />
            ))}
        </div>
        </>
    );
} 